import { lazy } from "react";
const BulkCollectionProcess = lazy(() => import("./BulkCollectionProcess"));

const BulkCollectionProcessRoutes = [
    {
        path: "/bulkcollectionprocess",
        component: BulkCollectionProcess,
    }
];

export default BulkCollectionProcessRoutes;